import { render, staticRenderFns } from "./course-join-dialog.vue?vue&type=template&id=1a697614"
import script from "./course-join-dialog.vue?vue&type=script&lang=js"
export * from "./course-join-dialog.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports